import React, { useMemo } from 'react';
import { LodingSquareTabbar } from '../../molecules';
import { MetricCard, SpinnerDotted } from '../../atoms';
import { CommentSection, RatingCard, Bargraph } from '../../organisms';
import { healthCheckMale, selfspouse, sirange, WalletIcon } from '../../../../assets/images';
import { commaingNumber } from '../../../../utils';
import { UserAlert } from '../../atoms/alerts';
import { UtilizationSankyChart } from '../../../tailwind/organisms';
import WalletUtilizationCommon from './WalletUtilizationCommon';
import { OverviewSectionIcon } from '../../../overview/OverviewSectionIcon';

const Vaccination = ({ loading, metricObj, ratingObj, futureAppObj, utilizationObj, sqaureTabHandler, selectedContractObj, walletUtilizationObj, benefitName}) => {
  const { ratingsPercent, totalratings, averagerating, commentSectionData } = ratingObj;
  const { dependent_dose_1, dependent_dose_2, dose_1, dose_2, total_dependent, total_vaccination, dose_3, dependent_dose_3 } = futureAppObj;
  const { barlabels, bardata, barBgColors, xAxesLabel } = utilizationObj;
  const { active_dose1, active_dose2, active_dose3, inactive_dose1, inactive_dose2, inactive_dose3, active_dependent_dose1,
          active_dependent_dose2, active_dependent_dose3, inactive_dependent_dose1, inactive_dependent_dose2, inactive_dependent_dose3,
          active_customers_count, unique_users, repeat_users }  = metricObj
  const { totalWalletAmount, walletEnable } = walletUtilizationObj;
 
  const sankyChartData = useMemo(() => {
    const employeeActiveVaccinationCount =  active_dose1 + active_dose2 + active_dose3 + active_dependent_dose1 + active_dependent_dose2 + active_dependent_dose3
    const employeeInactiveVaccinationCount = inactive_dose1 + inactive_dose2 + inactive_dose3 + inactive_dependent_dose1 + inactive_dependent_dose2 + inactive_dependent_dose3
    const activeEmployee = active_dose1 + active_dose2 + active_dose3
    const inactiveEmployee = inactive_dose1 + inactive_dose2 + inactive_dose3
    const activeDependent =  active_dependent_dose1 + active_dependent_dose2 + active_dependent_dose3
    const inactiveDependent = inactive_dependent_dose1 + inactive_dependent_dose2 + inactive_dependent_dose3

    const point1 = `Total vaccination (${metricObj.total_vaccination || 0})`

    const point2 = `Active employees (${employeeActiveVaccinationCount  || 0})`
    const point3 = `Inactive employees (${employeeInactiveVaccinationCount || 0})`


    const point4 = `For themselves (${activeEmployee || 0})`
    const point5 = `For dependents (${activeDependent || 0})`

    const point6 = `For themselves (${inactiveEmployee || 0}) `
    const point7 = `For dependents (${inactiveDependent || 0}) `

    const data = {
      nodes: [{ id: point1 }, { id: point2 }, { id: point3 }, { id: point4 }, { id: point5 }, { id: point6 }, { id: point7 },
            ],
      links: [
        {
          source: point1,
          target: point2,
          value: 50,
        },
        {
          source: point1,
          target: point3,
          value: 30,
        },
        {
          source: point2,
          target: point4,
          value: 25,
        },
        {
          source: point2,
          target: point5,
          value: 25,
        },
        {
          source: point3,
          target: point6,
          value: 15,
        },
        {
          source: point3,
          target: point7,
          value: 15,
        }
      ],
    }

    const colors = ['#1D4ED8', '#14866D', '#E8432C', '#4FAD96', '#60A5FA', '#475569', '#9CA3AF']
    return { data, colors }
  }, [metricObj.total_vaccination])


  return (
    <div>
      <p className='mt-8 text-xs font-semibold uppercase tracking-wider text-gray-500'>Sponsored vaccination</p>
      { !loading ?
        <>
          <div className='mt-4 grid grid-cols-1 gap-5'>
            <MetricCard
              icon={<OverviewSectionIcon name='vaccination' />}
              loading={loading}
              loaderHeight={178}
              title='Total vaccination'
              titleClasses='text-sm font-semibold text-gray-900'
              subTitle='Total vaccinations completed for employees and dependents'
              subTitleClasses='mt-1 text-xs leading-relaxed text-gray-600'
              metricValue={<span className='font-jetbrains-mono text-3xl font-semibold tabular-nums text-gray-900'>{commaingNumber(metricObj.total_vaccination)}</span>}
              metricClasses='mt-5 flex flex-col items-start gap-2 text-gray-700'
              classes='min-h-[178px] rounded-lg border-gray-300 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-400 hover:shadow-md'
            />
          </div>
        </> :
        <div className='h-40 flex items-center justify-center'><SpinnerDotted /></div>
      }
      <p className='mt-10 text-xs font-semibold uppercase tracking-wider text-gray-500'>COVID vaccination for employees</p>
      <div className='mt-4 grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-4'>
        {walletEnable && totalWalletAmount > 0 && (
          <MetricCard
            icon={<OverviewSectionIcon name='wallet' />}
            loading={loading}
            loaderHeight={178}
            title='Total amount added'
            titleClasses='text-sm font-semibold text-gray-900'
            subTitle='Total amount added for employee and dependent wallet utilization'
            subTitleClasses='mt-1 text-xs leading-relaxed text-gray-600'
            metricValue={<span className='font-jetbrains-mono text-3xl font-semibold tabular-nums text-gray-900'>₹{commaingNumber(totalWalletAmount)}</span>}
            metricClasses='mt-5 flex flex-col items-start gap-2 text-gray-700'
            classes='min-h-[178px] rounded-lg border-gray-300 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-400 hover:shadow-md'
          />
        )}
        <MetricCard
          icon={<OverviewSectionIcon name='vaccination' />}
          loaderHeight={178}
          loading={loading}
          title='Utilization of dose 1'
          titleClasses='text-sm font-semibold text-gray-900'
          metricValue={<span className='font-jetbrains-mono text-3xl font-semibold tabular-nums text-gray-900'>{commaingNumber(active_dose1 + inactive_dose1)}</span>}
          metricClasses='mt-5 flex flex-col items-start gap-2 text-gray-700'
          classes='min-h-[178px] rounded-lg border-gray-300 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-400 hover:shadow-md'
        />
        <MetricCard
          icon={<OverviewSectionIcon name='vaccination' />}
          loaderHeight={178}
          loading={loading}
          title='Utilization of dose 2'
          titleClasses='text-sm font-semibold text-gray-900'
          metricValue={<span className='font-jetbrains-mono text-3xl font-semibold tabular-nums text-gray-900'>{commaingNumber(active_dose2 + inactive_dose2)}</span>}
          metricClasses='mt-5 flex flex-col items-start gap-2 text-gray-700'
          classes='min-h-[178px] rounded-lg border-gray-300 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-400 hover:shadow-md'
        />
        <MetricCard
          icon={<OverviewSectionIcon name='vaccination' />}
          loaderHeight={178}
          loading={loading}
          title='Utilization of dose 3'
          titleClasses='text-sm font-semibold text-gray-900'
          metricValue={<span className='font-jetbrains-mono text-3xl font-semibold tabular-nums text-gray-900'>{commaingNumber(active_dose3 + inactive_dose3)}</span>}
          metricClasses='mt-5 flex flex-col items-start gap-2 text-gray-700'
          classes='min-h-[178px] rounded-lg border-gray-300 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-400 hover:shadow-md'
        />
      </div>

      <p className='mt-12 text-xs font-semibold uppercase tracking-wider text-gray-500'>COVID vaccination for dependents</p>
      <div className='mt-4 grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-3'>
        <MetricCard
          icon={<OverviewSectionIcon name='vaccination' />}
          loaderHeight={178}
          loading={loading}
          title='Utilization of dose 1'
          titleClasses='text-sm font-semibold text-gray-900'
          metricValue={<span className='font-jetbrains-mono text-3xl font-semibold tabular-nums text-gray-900'>{commaingNumber(active_dependent_dose1 + inactive_dependent_dose1)}</span>}
          metricClasses='mt-5 flex flex-col items-start gap-2 text-gray-700'
          classes='min-h-[178px] rounded-lg border-gray-300 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-400 hover:shadow-md'
        />
        <MetricCard
          icon={<OverviewSectionIcon name='vaccination' />}
          loaderHeight={178}
          loading={loading}
          title='Utilization of dose 2'
          titleClasses='text-sm font-semibold text-gray-900'
          metricValue={<span className='font-jetbrains-mono text-3xl font-semibold tabular-nums text-gray-900'>{commaingNumber(active_dependent_dose2 + inactive_dependent_dose2)}</span>}
          metricClasses='mt-5 flex flex-col items-start gap-2 text-gray-700'
          classes='min-h-[178px] rounded-lg border-gray-300 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-400 hover:shadow-md'
        />
        <MetricCard
          icon={<OverviewSectionIcon name='vaccination' />}
          loaderHeight={178}
          loading={loading}
          title='Utilization of dose 3'
          titleClasses='text-sm font-semibold text-gray-900'
          metricValue={<span className='font-jetbrains-mono text-3xl font-semibold tabular-nums text-gray-900'>{commaingNumber(active_dependent_dose3 + inactive_dependent_dose3)}</span>}
          metricClasses='mt-5 flex flex-col items-start gap-2 text-gray-700'
          classes='min-h-[178px] rounded-lg border-gray-300 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-400 hover:shadow-md'
        />
      </div>
      { !loading ?
        <> 
        <UtilizationSankyChart
          sankeyData={sankyChartData}
          classes='mt-10 rounded-xl border border-gray-200 bg-white px-6 py-10 shadow-sm md:px-9 md:py-14'
          height={450}
        />
        </> :
        <div className='h-40 flex items-center justify-center'><SpinnerDotted /></div>
      }

      <WalletUtilizationCommon metricObj={metricObj}  loading={loading} benefitName={benefitName} walletUtilizationObj={walletUtilizationObj} uniqueUsers={unique_users} activeCustomerCount={active_customers_count}/>
      
      <div className='mt-12 text-xs font-semibold uppercase tracking-wider text-gray-500'>Utilization based on</div>
      <LodingSquareTabbar loading={loading} loaderHeight={25} list={['Age', 'Gender']} handler={sqaureTabHandler} />
      <div
        className={
          'mt-4 overflow-hidden rounded-xl border border-gray-200 shadow-sm ' +
          (loading ? '' : 'bg-white ') +
          (bardata && bardata.length === 0 ? 'pt-6 ' : '')
        }
      >
        {bardata && bardata.length === 0 && (
          <UserAlert
            para={`${xAxesLabel} data is not available`}
            paraClasses=' font-semibold text-gray-600'
            imgClasses=' h-5 w-5'
            classes=' p-4 ml-6 mr-4'
          />
        )}
        <Bargraph
          loading={loading}
          loaderHeight={300}
          id='utilizationbargraph'
          data={bardata}
          labels={barlabels}
          backgroundColor={barBgColors}
          height='300px'
          type='bar'
          ticks={{
            min: 0,
            max: 120,
            stepSize: 20,
          }}
          dataPoints='percentage'
          barTag='percentage'
          xAxesLabel={xAxesLabel}
          yAxesLabel='Percentage of employees'
        />
      </div>

      <div className='mt-12 flex flex-col gap-8 lg:flex-row'>
        <div className='flex flex-col pr-4 lg:w-2/4'>
          <div className='mb-1 text-xs font-semibold uppercase tracking-wider text-gray-500'>Ratings and reviews</div>
          <div className='mb-3 text-sm text-gray-600'>These ratings are captured after completing the vaccination.</div>
          <RatingCard
            loading={loading}
            loaderHeight={200}
            rating={averagerating}
            number_of_ratings={totalratings}
            five_star_rating={ratingsPercent && ratingsPercent[4]}
            four_star_rating={ratingsPercent && ratingsPercent[3]}
            three_star_rating={ratingsPercent && ratingsPercent[2]}
            two_star_rating={ratingsPercent && ratingsPercent[1]}
            one_star_rating={ratingsPercent && ratingsPercent[0]}
            classes='h-full'
          />
        </div>

        <div className='flex w-full flex-col lg:w-2/4'>
          <div className='mb-1 text-xs font-semibold uppercase tracking-wider text-gray-500'>Top comments</div>
          <div className='mb-3 text-sm text-gray-600'>These reviews are captured after completing the vaccination.</div>
          <CommentSection loading={loading} loaderHeight={200} points={commentSectionData || []} classes='h-full' />
        </div>
      </div>
      { selectedContractObj.text.includes('Current') &&
        <>
          <p className='mt-12 mb-0 text-xs font-semibold uppercase tracking-wider text-gray-500'>Future appointments</p>
          <p className='mt-4 text-xs font-semibold uppercase tracking-wider text-gray-500'>COVID vaccination for employees</p>
          <div className='mt-4 grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-4'>
            <MetricCard
              variant='ds-default'
              icon={<OverviewSectionIcon name='vaccination' />}
              loaderHeight={120}
              loading={loading}
              title='Employees future appointments'
              metricValue={commaingNumber(total_vaccination)}
              classes='min-w-0 flex-1'
            />
            <MetricCard
              variant='ds-default'
              icon={<OverviewSectionIcon name='vaccination' />}
              loaderHeight={120}
              loading={loading}
              title='Dose 1 appointments'
              metricValue={commaingNumber(dose_1)}
              classes='min-w-0 flex-1'
            />
            <MetricCard
              variant='ds-default'
              icon={<OverviewSectionIcon name='vaccination' />}
              loaderHeight={120}
              loading={loading}
              title='Dose 2 appointments'
              metricValue={commaingNumber(dose_2)}
              classes='min-w-0 flex-1'
            />
            <MetricCard
              variant='ds-default'
              icon={<OverviewSectionIcon name='vaccination' />}
              loaderHeight={120}
              loading={loading}
              title='Dose 3 appointments'
              metricValue={commaingNumber(dose_3)}
              classes='min-w-0 flex-1'
            />
          </div>

          <p className='mt-12 text-xs font-semibold uppercase tracking-wider text-gray-500'>COVID vaccination for dependents</p>
          <div className='mt-4 grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-4'>
            <MetricCard
              variant='ds-default'
              icon={<OverviewSectionIcon name='vaccination' />}
              loaderHeight={120}
              loading={loading}
              title='Dependent future appointments'
              metricValue={commaingNumber(total_dependent)}
              classes='min-w-0 flex-1'
            />
            <MetricCard
              variant='ds-default'
              icon={<OverviewSectionIcon name='vaccination' />}
              loaderHeight={120}
              loading={loading}
              title='Dose 1 appointments'
              metricValue={commaingNumber(dependent_dose_1)}
              classes='min-w-0 flex-1'
            />
            <MetricCard
              variant='ds-default'
              icon={<OverviewSectionIcon name='vaccination' />}
              loaderHeight={120}
              loading={loading}
              title='Dose 2 appointments'
              metricValue={commaingNumber(dependent_dose_2)}
              classes='min-w-0 flex-1'
            />
            <MetricCard
              variant='ds-default'
              icon={<OverviewSectionIcon name='vaccination' />}
              loaderHeight={120}
              loading={loading}
              title='Dose 3 appointments'
              metricValue={commaingNumber(dependent_dose_3)}
              classes='min-w-0 flex-1'
            />
          </div>
        </>
      }
    </div>
  );
};

export default Vaccination;